import React from 'react'
import Footer from '../global/footer'
import footerStaticQuery from '../global/footer/footerStaticQuery'
import NewFooter from '../global/newFooter'

import { LocaleCodes } from '../../constants/localization.constants'
import { returnSelectedLocaleData } from '../../utils/functions.utils'

const RenderFooter = ({ footerData, minimalFooter, locale }: any) => {
  const staticQueryFooterData: any = footerStaticQuery.allContentfulNavMenu()
  const navDataList = footerData
    ? footerData.allContentfulNavMenu
    : staticQueryFooterData?.allContentfulNavMenu

  const lang = locale || LocaleCodes.ENGLISH.code
  const localizedNavData = returnSelectedLocaleData(navDataList?.nodes || [], lang)
  let oldFooterData = localizedNavData.filter((item: any) => !item?.location?.startsWith('New '))
  let newFooterData = localizedNavData.filter((item: any) => item?.location?.startsWith('New '))

  const oldFooter = {
    allContentfulNavMenu: {
      nodes: oldFooterData,
    },
  }

  const newFooter = {
    allContentfulNavMenu: {
      nodes: newFooterData,
    },
  }

  if (minimalFooter) {
    return <Footer minimalFooter={minimalFooter} footerData={newFooter} locale={locale} />
  }

  //* New prefix takes precendence
  return newFooterData.length ? (
    <NewFooter footerData={newFooterData[0]} locale={locale} />
  ) : (
    <Footer minimalFooter={minimalFooter} footerData={oldFooter} locale={locale} />
  )
}

export default RenderFooter
